export enum StatusEnum {
  DRAFT = "DRAFT",
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED',
  SUCCEED = 'SUCCEED',
  FAILED = 'FAILED',
  WAITING = 'WAITING',
  TRANSFERRED = 'TRANSFERRED',
  EXPIRED = 'EXPIRED',
  PAID = 'PAID'
}
